module.exports = __webpack_public_path__ + "img/filled-cancel.2e31223b.svg";